import React, { useState } from "react";
import { useDispatch } from "react-redux";
import apiJurados from "../../../../api/Jurados/api-jurados";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { Jurado} from "../../../../models/JuradosModel/jurados.model";
import { guardarJuradosCriterios } from "../../../../redux/actions/juradosAction";
import { openNotification } from '../../../../utils/Notifactions';


// data static
const jurados = [
  {
    index: 1,
    nombre: "Jurado",
    documento: 123456789,
    codigo: 23401,
    asignado: [{ index: 1, nombre: "Nombre de proyecto", codigo: "codigo", linea: "Línea", categoria: "categoría" }],
    area: [{ value: "Artes visuales", text: "Artes visuales" }],
    categoria_linea_convocatoria: [{ value: 55, text: "Core" }],
  },
];

export const useModalAsignarJurado = () => {
  const dispatch = useDispatch();
  const [allJurados, setAllJurados] = useState<any>(jurados);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [juradosSeleccionados, setJuradosSeleccionados] = useState<Array<Jurado>>([]);
  const [modalVerProyectos, setModalVerProyectos] = useState(false);
  const [juradoSeleccionado, setJuradoSeleccionado] = useState<any>({});
  // functions

  const [datosFiltrados, setDatosFiltrados] = useState<any[]>([])
  const cargarJurados = async () => {
    try {
      let { data } = await apiJurados.consultarProjectosJurados();
      setDatosFiltrados(data.juries)
      return setAllJurados(data.juries);
    } catch (error) {
      console.log(error)
    }
  };
  const cambiarCheckbox = (index: number) => {
    let infoupdate = datosFiltrados.map((data: any) => {
      if (data.id_jurado === index) {
        return {
          ...data,
          checked: !data.checked,
        };
      }
      return {
        ...data,
      };
    });
    return setDatosFiltrados(infoupdate);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    setCantidadPáginas(value);
  };
  const agregarJurado = (jurado: Jurado, e: any) => {
    let infoupdate: Array<Jurado> = [...juradosSeleccionados, jurado];
    if (!e.target.checked) {
      infoupdate = infoupdate.filter((data: Jurado) => data.id_jurado !== jurado.id_jurado);
    }
    if (e.target.checked) {
      if (juradosSeleccionados.length === 3) {
        return openNotification({ titulo: "Error", descripcion: "No se pueden seleccionar mas de 3 jurados", placement: "bottomRight" });
      }
    }
    cambiarCheckbox(jurado.id_jurado);
    dispatch(guardarJuradosCriterios(infoupdate));
    return setJuradosSeleccionados(infoupdate);
  }


  const [areas, setAreas] = useState<any>([]);
  const obtenerAreas = async () => {
    try {
      const areas = await apiMaestras.obtenerAreas();
      setAreas(areas);
    } catch (error) {
      console.log(error)
    }
  }



  return {
    alljurados: allJurados,
    setAllJurados,
    cantidadpáginas: cantidadPáginas,
    cambiarCantidadPaginas,
    juradosseleccionados: juradosSeleccionados,
    modalverproyectos: modalVerProyectos,
    setModalVerProyectos,
    juradoseleccionado: juradoSeleccionado,
    setJuradoSeleccionado,
    cargarJurados,
    agregarJurado,
    areas,
    obtenerAreas,
    datosFiltrados,
    setDatosFiltrados
  };
};
